exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\np[data-v-9a7cd71c] {\r\n    font-weight: 700;\r\n    font-size: 22px;\r\n    line-height: 28px;\r\n    margin: 0;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-9a7cd71c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/deleted/deleted-dealer.vue
// module id = 614
// module chunks = 0